import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatBusinessLineModel } from 'src/app/model/cat-business-line.model';

@Injectable({
  providedIn: 'root'
})
export class CatBusinessLineService {
  private url: string;

  ////////////////
  constructor(
    private http: HttpClient
  ) {
    this.url = environment.services_url;
  }

  //
  getAll = () => {
    return this.http.get(`${this.url}/CatBusinessLine/List`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  save = (userName: string, businessLine: CatBusinessLineModel) => {
    return this.http.post(`${this.url}/CatBusinessLine/saveBusinessLine/${userName}`, businessLine)
      .pipe(
        map((resp: any) => resp)
      );
  }

  upload = (userName: string, file: File, replace: boolean) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('table', 'businessLine');
    formData.append('replace', String(replace));
    return this.http.post(`${this.url}/upload/save`, formData)
      .pipe(
        map((resp: any) => resp)
      );
  }

  downloadLayout = () => this.http.get(`${this.url}/CatBusinessLine/DownloadLayout`, { responseType: 'blob' });
}
